import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const AuthContext = createContext(null);
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
let refreshing = null;
export const errorText = data => Array.isArray(data?.detail) ? data.detail.map(e => e.msg?.replace('Value error, ', '')).join(' ') : typeof data?.detail === 'string' ? data.detail : 'Something went wrong. Please try again.';

export async function apiRequest(path, options = {}) {
  const config = { ...options, credentials: 'include', headers: { ...(options.body && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}), ...options.headers } };
  let response = await fetch(`${BASE}${path}`, config);
  if (response.status === 401 && !path.startsWith('/auth/')) {
    if (!refreshing) refreshing = fetch(`${BASE}/auth/refresh`, { method: 'POST', credentials: 'include' }).finally(() => { refreshing = null; });
    const refreshed = await refreshing;
    if (refreshed.ok) response = await fetch(`${BASE}${path}`, config);
  }
  return response;
}

export async function api(path, options = {}) {
  const response = await apiRequest(path, options);
  const data = await response.json();
  if (!response.ok) throw new Error(errorText(data));
  return data;
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const refreshUser = useCallback(async () => {
    try {
      let response = await apiRequest('/auth/me');
      if (response.status === 401) { const refreshed = await apiRequest('/auth/refresh', { method: 'POST' }); if (refreshed.ok) response = await apiRequest('/auth/me'); }
      setUser(response.ok ? await response.json() : null);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    if (location.hash?.includes('session_id=')) { setLoading(false); return; }
    refreshUser();
  // Only check once at provider mount. Callback owns the one-time exchange.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshUser]);
  const logout = async () => { await api('/auth/logout', { method: 'POST' }); setUser(null); };
  return <AuthContext.Provider value={{ user, setUser, loading, refreshUser, logout }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => useContext(AuthContext);

export const googleSignIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/dashboard';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};